export type Maybe<T> = T | null

export type Scalars = {
  ID: number
  Boolean: boolean
  String: string
  Int: number
}

export enum IncentiveType {
  TWO_YEARS = "two_years",
  ONE_YEAR = "one_year",
  NINE_MONTHS = "nine_months",
  SIX_MONTHS = "six_months",
  THREE_MONTHS = "three_months",
}

export enum StockOptionType {
  ISO = "iso",
  NSO = "nso",
}

export enum NavOption {
  ACCOUNT = "account",
  COMPLIANCE = "compliance",
  COMPANY = "company",
  DOCUMENTS = "documents",
  CURRENT_OFFER = "your_deals",
  RESOURCES = "resources",
  TAX_CALCULATION = "tax_calculation",
  DASHBOARD = "dashboard",
  CLIENT = "client",
  NDA = "nda",
  PIPELINE = "pipeline",
  HOTLIST = "hotlist",
  FMV_REVIEW = "fmv_review",
  IRR = "irr",
  EMPLOYEE_OUTREACH = "employee_outreach",
  COMMISSIONS = "commissions",
  REPORTS = "reports",
  SETTINGS = "settings",
  PORTAL_EXTRACTION = "portal_extraction",
  PAYMENT_CENTER = "payment_center",
  STRANDED_VALUE = "stranded_value",
  ACTIVITY = "activity",
  // BACKGROUND_CHECK = "background_check"
}

export enum ComplianceType {
  BACKGROUND_CHECK = "Background Check",
  NDA = "NDA",
}

export enum DocumentType {
  DEAL = "deal",
  COMPLIANCE = "compliance"
}

export enum DealStep {
  COMPLETE_NDA_FORM = "complete_nda_form",
  SIGN_NDA = "sign_nda",
  UPLOAD_GRANT_DOCS = "upload_grant_docs",
  ACCEPT_OFFER = "accept_offer",
  COMPLETE_BC_FORM = "complete_bc_form",
  SIGN_BC = "sign_bc",
  SCHEDULE_CLOSING_MEETING = "schedule_closing_meeting",
  SIGN_CONTRACT = "sign_contract",
  SEND_WIRE_INFO = "send_wire_info"
}

export enum PortalRole {
  CLIENT = "client",
  ESO_PERSON = "esoPerson",
}
